export { default } from "./ProductIcon";
